<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { NutsAddress } from '@/utils/address';

export default defineComponent({
  name: 'MailingAddress',
  props: {
    address: { required: true, type: Object as PropType<NutsAddress> },
  },
});
</script>

<template>
  <div class="text-sm leading-5 md:text-base">
    <div>{{ address.street1 }} {{ address.street2 }}</div>
    <div>{{ address.city }}</div>
    <div>{{ address.state }}</div>
    <div>{{ address.postalCode }}</div>
  </div>
</template>
